import React from 'react';
import { Link } from 'react-router-dom';



const Footer = () => {
    const handleWhatsAppClick = () => {

        window.open('https://wa.me/+917388873900', '_blank');
    };
    return (

        <>
            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-section">
                        <h3>For Patients </h3>
                        <ul>
                            <Link to='/' style={{ color: 'white' }}><li>  Find a Doctor</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>  Book Appointment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>  Treatment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>  Emergency 24*7</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>  Latest Technology</li></Link>
                        </ul>
                        
                    </div>
                    <div className="footer-section">
                        <h3>Specialities</h3>
                        <ul>
                            <Link to='/' style={{ color: 'white' }}><li>  Gynea Treatment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li> Cardiology Treatment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>Orthopedics Treatment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>Oncology Treatment</li></Link>
                            <Link to='/' style={{ color: 'white' }}><li>Neurology Treatment</li></Link>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Contact</h3>
                        <p>Email: <a href="mailto:">hopehospital@gmail.com</a></p>
                        <p>Phone: <a href="tel:917388873900">917388873900</a></p>
                        <p>Phone: <a href="tel:917905170081">917905170081</a></p>
                        <p> <a href='https://maps.app.goo.gl/PWHwD1KXAxamRgeq5' style={{ color: 'white' }}>Address: Manas Vihar, Liberty Colony Park, Sarvodaya Nagar, Indira Nagar, Lucknow, Uttar Pradesh 226016</a>  </p>

                      


                    </div>
                    <div className="footer-section">
                        <h3> Social Sites</h3>
                        
                        <ul className="social-links">
                            <li><a href="#"><i className="fab fa-facebook-f"></i> Facebook</a></li><br />
                            <li><a href="#"><i className="fab fa-twitter"></i> Twitter</a></li><br />
                            <li><a href="#"><i className="fab fa-instagram"></i> Instagram</a></li><br />
                            <li><a href="#"><i className="fab fa-youtube"></i> YouTube</a></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Hope  Rise Multi Speciality Hospital . All Rights Reserved.</p>
                </div>
            </footer>

            <button className="whatsapp-button" onClick={handleWhatsAppClick}>
                <i className="fab fa-whatsapp"></i>
            </button>

        </>
    );
};

export default Footer;
